export enum ContentAccess {
    Unknown = "unknown",
    None = "none",
    Credits = "credits",
    Unlimited = "unlimited"
}
